//
// Copyright (c) 2022-2026 Winlin
//
// SPDX-License-Identifier: MIT
//
import React from 'react';

// The context for env of API /terraform/v1/mgmt/envs
export const SrsEnvContext = React.createContext();

